var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-lg-row mb-3"},[_c('div',{staticClass:"flex-grow-1"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.right)?_c('div',{staticClass:"d-flex flex-md-row gap-2 justify-content-end align-items-center"},[_vm._t("right")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }